import { render, staticRenderFns } from "./basicsSetting.vue?vue&type=template&id=dadca210&scoped=true"
import script from "./basicsSetting.vue?vue&type=script&lang=js"
export * from "./basicsSetting.vue?vue&type=script&lang=js"
import style0 from "./basicsSetting.vue?vue&type=style&index=0&id=dadca210&prod&lang=scss&scoped=true"
import style1 from "./basicsSetting.vue?vue&type=style&index=1&id=dadca210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadca210",
  null
  
)

export default component.exports